import { $largestCategoryId, $largestCategoryIdApi } from '@stores/dataStores';

export function getNewCategoryId() {
  const newId = $largestCategoryId.getState() + 1;
  $largestCategoryIdApi.set(newId);
  return newId;
}
